"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ArrowIndicatorDownOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorDownOutline"));
var ArrowIndicatorUpOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorUpOutline"));
var dropdown_style_component_1 = require("./dropdown.style.component");
var text_field_style_component_1 = require("../inputs/text-field.style.component");
var use_outside_hover_hook_1 = __importDefault(require("../../hooks/use-outside-hover.hook"));
exports.InternalDropDown = function (props) {
    var title = props.title, options = props.options, value = props.value, defaultOption = props.defaultOption, disabled = props.disabled, maxHeight = props.maxHeight, dropUp = props.dropUp, onChange = props.onChange, embedded = props.embedded, invalid = props.invalid, errorMessage = props.errorMessage, testID = props.testID, onToggle = props.onToggle, isOpen = props.isOpen;
    var _a = react_1.useState(false), mouseHover = _a[0], setMouseHover = _a[1];
    use_outside_hover_hook_1.default(mouseHover, onToggle);
    var selected = options.find(function (option) { return option.value === value; });
    var toggle = function () {
        disabled || onToggle(!isOpen);
    };
    return (react_1.default.createElement(dropdown_style_component_1.Container, { "data-test-id": testID },
        title && react_1.default.createElement(text_field_style_component_1.Title, null, title),
        react_1.default.createElement(dropdown_style_component_1.Wrapper, null,
            react_1.default.createElement(dropdown_style_component_1.FieldWrapper, { "data-test-id": 'dropdown-wrapper', embedded: embedded, invalid: invalid, onMouseOver: function () { return setMouseHover(true); }, onClick: toggle, onMouseOut: function () { return setMouseHover(false); }, disabled: disabled },
                react_1.default.createElement(dropdown_style_component_1.ChosenOptionContainer, { disabled: disabled, embedded: embedded },
                    selected && react_1.default.createElement(dropdown_style_component_1.Field, { className: "dropdown-value" }, selected.label),
                    !selected && react_1.default.createElement(dropdown_style_component_1.DefaultOption, { className: "dropdown-value" }, defaultOption),
                    isOpen ? react_1.default.createElement(ArrowIndicatorUpOutline_1.default, null) : react_1.default.createElement(ArrowIndicatorDownOutline_1.default, null))),
            invalid && errorMessage && react_1.default.createElement(text_field_style_component_1.TextError, null, errorMessage),
            isOpen && (react_1.default.createElement(dropdown_style_component_1.Drawer, { maxHeight: maxHeight, dropUp: dropUp },
                react_1.default.createElement(dropdown_style_component_1.OptionsList, null, options.map(function (option, index) { return (react_1.default.createElement(dropdown_style_component_1.OptionsListElement, { className: "dropdown-option", "data-test-id": 'option' + index.toString(), onClick: function () {
                        onChange(option.value);
                        toggle();
                    }, key: index }, option.label)); })))))));
};
var Dropdown = function (props) {
    var _a = react_1.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    return react_1.default.createElement(exports.InternalDropDown, __assign({}, props, { isOpen: isOpen, onToggle: setIsOpen }));
};
Dropdown.displayName = 'Dropdown';
exports.default = Dropdown;
//# sourceMappingURL=dropdown.component.js.map